import { Box, Icon, IconButton } from "@chakra-ui/react";
import { SizeProp } from "chakra-react-select";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaFileDownload } from "react-icons/fa";
import { useDocumentDownloader } from "./useDocumentDownloader";

interface Props {
  documentId: string;
  isSignedDocument?: boolean;
  // When set, downloads via the sourcing-event-scoped Q&A attachment endpoint instead of the generic one.
  eventId?: string;
  size?: SizeProp;
}

export const DownloadDocumentIconButton = ({ documentId, isSignedDocument, eventId, size = "md" }: Props) => {
  const { t } = useTranslation();
  const { getDownloadLink, getSeV2AttachmentDownloadLink } = useDocumentDownloader();
  const [downloadLink, setDownloadLink] = useState<string>();
  const [isCreatingLink, setIsCreatingLink] = useState<boolean>(false);
  const ref = useRef<HTMLAnchorElement>(null);

  return (
    <Box>
      <IconButton
        id="download-file-popover"
        aria-label={t("Download file")}
        isLoading={isCreatingLink}
        display="flex"
        justifyContent="center"
        alignItems="center"
        size={size}
        variant="ghost"
        onClick={async () => {
          if (downloadLink) {
            ref.current?.click();
            return;
          }
          setIsCreatingLink(true);
          try {
            const link = eventId
              ? await getSeV2AttachmentDownloadLink(eventId, documentId)
              : await getDownloadLink(documentId, isSignedDocument ?? false);
            if (link && ref.current) {
              setDownloadLink(link);
              ref.current.href = link;
              ref.current.click();
            }
          } catch {
            return;
          } finally {
            setIsCreatingLink(false);
          }
        }}
        icon={<Icon as={FaFileDownload} />}
      />
      <a ref={ref} style={{ display: "none" }} target="_blank" rel="noreferrer" aria-hidden="true" tabIndex={-1} />
    </Box>
  );
};
